import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import RestorePost from '../../components/actions/restore-post';
import { BtnContactShop } from '../../components/btn-contact-shop';
import Svg from '../../components/icons/svg';
import ModalSharePost from '../../components/modal/modal-share-post';
import InfoCaption from '../../components/posts/info-caption';
import VideoPostItemSm from '../../components/posts/video-post-item-sm';
import Comments from '../../pages/post/comments';
import Caroumal from '../../plugin/caroumal/caroumal';

const DeletePost = React.lazy(() => import(/* webpackChunkName: "post-admin-actions" */ '../../components/actions/delete-post'));
const UpdatePost = React.lazy(() => import(/* webpackChunkName: "post-admin-actions" */ '../../components/actions/update-post'));

const PostSmItem = (props) => {
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);
  const [data, setData] = useState(props.data);
  const [descHasMore, setDescHasMor] = useState(null);
  const [descPreview, setDescPreview] = useState('');

  const updateSmPost = (values) => {
    const keys = Object.keys(values);

    setData((prevState) => {
      const newState = prevState;
      for (const key of keys) {
        newState[key] = values[key];
      }
      return { ...prevState, ...newState };
    });
  };

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
  const p = {};
  [p.newComments, p.setNewComments] = useState({ list: [] });
  [p.removeCount, p.setRemoveCount] = useState(0);
  [p.showComments, p.setShowComments] = useState(false);
  p.showCommentsArea = () => {
    p.setShowComments(true);
  };
  p.hideCommentsArea = () => {
    p.setShowComments(false);
  };
  p.handleClickOnCommentForm = (e) => {
    if (admin.auth.value || member.auth.value) {
      p.setShowComments(true);
    }
  };
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

  useEffect(() => {
    let preview = '';
    let newLineSplit = data.description ? data.description.split('\n') : null;
    if (newLineSplit && newLineSplit[0].length > 120) {
      let previewSplit = newLineSplit[0].split(' ');
      previewSplit.pop();
      preview = previewSplit.join(' ');
      setDescPreview(preview);
    } else {
      preview = newLineSplit ? newLineSplit[0] : '';
      setDescPreview(preview);
    }
    if (newLineSplit && newLineSplit.length > 1) {
      setDescHasMor(true);
    } else {
      if (newLineSplit && newLineSplit[0].length > preview.length) {
        setDescHasMor(true);
      } else {
        setDescHasMor(false);
      }
    }
  }, []);

  function handleMoreButton() {
    setDescHasMor(false);
  }

  return (
    <React.Fragment>
      {p.showComments && <Comments data={data} postProvider={p} />}

      <article className="post w-100 p-0 mb-20p">
        <div className={'post-header f-row align-items-center justify-content-between'}>
          {data.title?.length > 0 ? (
            data.title
          ) : (
            <Link
              to={`/${data.gc ? 'gallery-' : ''}category/${data.category.id + '/' + data.category.uniqTitle}`}
              className="d-inline-block font-size-5 color-main"
            >
              {data.category.title}
            </Link>
          )}
          <div className="f-row actions" style={{ left: '-9px' }}>
            {admin.auth.value && data.trash === '1' && <RestorePost id={data.id} />}
            {admin.auth.value && (
              <React.Suspense fallback={null}>
                <UpdatePost updateSmPost={updateSmPost} data={data} />
                <DeletePost id={data.id} />
              </React.Suspense>
            )}
          </div>
        </div>

        <div className="media">
          <div className="w-100 d-block">
            <div
              className={`media-content d-block ${data.media.length > 1 ? 'carousel' : ''}`}
              style={{ height: document.body.clientWidth }}
            >
              {data.media.length === 1 && SingleItem(data)}
              {data.media.length > 1 && Carousel(data)}
              {data.version === 1 && (
                <div className={'info-caption-wrapper'}>
                  {(data?.shop ?? []).map((row, i) => {
                    return <InfoCaption {...row} key={row.id} />;
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="reactions">
          <section className="btns f-row align-content-center justify-content-between">
            <BtnContactShop shopData={data?.shop} path={`post/${data.id}`} />

            <div className="f-row">
              <ModalSharePost path={`post/${data.id}`} />

              <button
                className="d-flex align-items-center justify-content-center c-p p-8p ml-n8p"
                onClick={p.showCommentsArea}
              >
                <div className="align-items-center justify-content-center">
                  <Svg name={'comment'} label="Comment" fill="#262626" height="24" width="24" />
                </div>
              </button>
            </div>
          </section>

          <div className="info f-grow-1 f-shrink-1">
            <div className="f-00auto justify-content-start align-content-stretch align-content-stretch">
              {data.description?.length > 0 && (
                <div className="description f-00auto justify-content-start align-content-stretch align-content-stretch">
                  <div className="font-size-5 line-height-3 f-11auto min-wh-0 d-block">
                    {descHasMore === false && (
                      <span className="font-size-5">
                        {data.description &&
                          data.description.split('\n').map((str, i) => {
                            return (
                              <React.Fragment key={str + i}>
                                {str}
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </span>
                    )}
                    {descHasMore === true && (
                      <span className="ow-break-word">
                        <span className="font-size-5">{descPreview} ...</span>
                        <span className="w-space-nowrap">
                          ...
                          <button type="button" className="more-button" onClick={handleMoreButton}>
                            بیشتر
                          </button>
                        </span>
                      </span>
                    )}
                  </div>
                </div>
              )}

              {data.comments.count + p.newComments.list.length - p.removeCount > 2 && (
                <div
                  className="f-00auto justify-content-start align-items-stretch align-content-stretch mb-8p"
                  onClick={p.showCommentsArea}
                >
                  <span className="view-all">
                    مشاهده همه {data.comments.count + p.newComments.list.length - p.removeCount} نظر
                  </span>
                </div>
              )}

              <div>
                {p.newComments.list.map((comment) => {
                  return (
                    <div className="font-size-4 mb-8p wb-break-all" key={'gbfu' + comment.id}>
                      {comment.content}
                    </div>
                  );
                })}
                {data.comments.list[0] && (
                  <div className="font-size-4 mb-8p wb-break-all">{data.comments.list[0].content}</div>
                )}
                {data.comments.list[1] && (
                  <div className="font-size-4 mb-8p wb-break-all">{data.comments.list[1].content}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/*<div*/}
        {/*  style={*/}
        {/*      {*/}
        {/*          position: "absolute", bottom: "120px", left: "10px", fontSize: "14px", lineHeight: 1, background: "seagreen", letterSpacing: '1px',*/}
        {/*          padding: "4px 6px 2px", boxShadow: "0 2px 5px 1px rgba(0,0,0,.3)", borderRadius: "3px", color: "white", zIndex: 1*/}
        {/*      }*/}
        {/*  }*/}
        {/*>*/}
        {/*    {formatWithCommas(data.place)}*/}
        {/*</div>*/}
      </article>
    </React.Fragment>
  );
};

// <media show setting. single or slide>
const SingleItem = (post) => {
  const split = post.media[0].split('.');
  return split[split.length - 1] === 'jpg' ? (
    <img src={post.media[0].replace('localhost/', 'localhost:98/')} alt={post?.title} className="media-img d-block" />
  ) : (
    <VideoPostItemSm src={post.media[0]} turn={0} />
  );
};

const Carousel = (post) => {
  const onTranslate = (e) => {
    try {
      const items = e.target.childNodes[0].childNodes[0].childNodes;
      const totalPage = parseInt(e.item.count) - 1;
      const index = parseInt(e.item.index);
      if (index === 0) {
        const video = items[1].querySelector('video');
        if (video) {
          setTimeout(() => {
            video.currentTime = 0;
          }, 450);
          video.pause();
          const div = items[1].querySelector('div.media-control-caption');
          if (div) {
            div.classList.remove('hide-control');
          }
        }
      } else {
        if (index === totalPage) {
          const video = items[index - 1].querySelector('video');
          if (video) {
            setTimeout(() => {
              video.currentTime = 0;
            }, 450);
            video.pause();
            const div = items[index - 1].querySelector('div.media-control-caption');
            if (div) {
              div.classList.remove('hide-control');
            }
          }
        } else {
          const video1 = items[index - 1].querySelector('video');
          const video2 = items[index + 1].querySelector('video');
          if (video1) {
            setTimeout(() => {
              video1.currentTime = 0;
            }, 450);
            video1.pause();
            const div = items[index - 1].querySelector('div.media-control-caption');
            if (div) {
              div.classList.remove('hide-control');
            }
          }
          if (video2) {
            setTimeout(() => {
              video2.currentTime = 0;
            }, 450);
            video2.pause();
            const div = items[index + 1].querySelector('div.media-control-caption');
            if (div) {
              div.classList.remove('hide-control');
            }
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onTranslated = (e) => {
    try {
      const index = e.item.index;
      const items = e.target.childNodes[0].childNodes[0].childNodes;
      const video = items[index].querySelector('video');
      if (video) {
        video.play();
        const div = items[index].querySelector('div.media-control-caption');
        if (div) {
          div.classList.add('hide-control');
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Caroumal
      onTranslate={onTranslate}
      onTranslated={onTranslated}
      className={'media-carousel'}
      id={'media-carousel'}
      items={1}
      autoWidth={false}
      rtl={true}
      arrows={false}
      dots={true}
      draggable={true}
      minMoveToToggle={5}
    >
      {post.media.map((src, i) => {
        const split = src.split('.');
        return split[split.length - 1] === 'jpg' ? (
          <img src={src} alt={post?.title} className="media-img" key={src + i} />
        ) : (
          <VideoPostItemSm src={src} turn={i} key={'postItem' + i} />
        );
      })}
    </Caroumal>
  );
};
// </media show setting. single or slide>

export default React.memo(PostSmItem);
